import { defineStore } from 'pinia';
import { ref } from 'vue';

const MAX_RECENT_NAVIGATION_ITEMS = 3;

export const useRecentNavigationStore = defineStore(
  'recentNavigation',
  () => {
    const itemIds = ref<string[]>([]);

    function addRecentItem(itemId: string): void {
      const nextIds = itemIds.value.filter((existingId) => existingId !== itemId);
      nextIds.unshift(itemId);

      if (nextIds.length > MAX_RECENT_NAVIGATION_ITEMS) {
        nextIds.length = MAX_RECENT_NAVIGATION_ITEMS;
      }

      itemIds.value = nextIds;
    }

    function clearRecentItems(): void {
      itemIds.value = [];
    }

    return {
      itemIds,
      addRecentItem,
      clearRecentItems,
    };
  },
  {
    persist: [
      {
        storage: localStorage,
        pick: ['itemIds'],
      },
    ],
  },
);
